var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalAllotmentsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#D1E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6198 7.93606C12.9917 7.02131 11.0083 7.02131 9.38018 7.93606L3.34356 11.3276C1.88548 12.1468 1.88548 14.2543 3.34356 15.0735L9.38018 18.465C11.0083 19.3798 12.9917 19.3798 14.6198 18.465L20.6564 15.0735C22.1145 14.2543 22.1145 12.1468 20.6564 11.3276L14.6198 7.93606Z",
    fill: "#1570EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97517 21.3379C1.89805 22.2779 2.02084 24.0812 3.34356 24.8243L9.38018 28.2159C11.0083 29.1306 12.9917 29.1306 14.6198 28.2159L20.6564 24.8243C21.9792 24.0812 22.102 22.2779 21.0248 21.3379L15.3545 24.5236C13.2701 25.6947 10.7299 25.6947 8.64545 24.5236L2.97517 21.3379Z",
    fill: "#1570EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81218 16.4961C1.91468 17.4681 2.0918 19.1208 3.34356 19.8241L9.38018 23.2157C11.0083 24.1304 12.9917 24.1304 14.6198 23.2157L20.6564 19.8241C21.9082 19.1208 22.0853 17.4681 21.1878 16.4961L15.3545 19.7734C13.2701 20.9445 10.7299 20.9445 8.64545 19.7734L2.81218 16.4961Z",
    fill: "#1570EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalAllotmentsIcon);
export default __webpack_public_path__ + "static/media/TotalAllotmentsIcon.6f301e71198e4fd54448f2e24a733700.svg";
export { ForwardRef as ReactComponent };